module.exports = __webpack_public_path__ + "static/img/GalaxyTabS5e.9c67d42a.png";